import Swiper from "swiper/swiper-bundle.mjs";

export const initSwipers = (root = document) => {
  root.querySelectorAll(".horizontal").forEach((element) => {
    if (element.dataset.swiperInit) {
      return;
    }

    element.dataset.swiperInit = "true";

    new Swiper(element, {
      slidesOffsetAfter: 12,
      slidesOffsetBefore: 12,
      slidesPerView: 1.2,
      spaceBetween: 12,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      breakpoints: {
        640: {
          slidesOffsetAfter: 24,
          slidesOffsetBefore: 24,
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        1024: {
          slidesOffsetAfter: 24,
          slidesOffsetBefore: 24,
          slidesPerView: 3.2,
          spaceBetween: 24,
        },
      },
    });
  });
};

initSwipers();
